export default "__VITE_ASSET__C8qjrs8M__"